import React, { useEffect, useState } from 'react'
import Sectionbureau from '../../components/Sectionbureau/Sectionbureau'
import './Selection.css'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FiArrowRight, FiArrowUpRight } from 'react-icons/fi'

const Selectin = () => {
  const [infob, setInfob] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [chaiseThumb, setChaiseThumb] = useState(null)

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/bureau/lister8`)
      .then(res => {
        setInfob(res.data)
        setIsLoading(false)
      })
      .catch(err => {
        console.error("Erreur lors du chargement des données:", err)
        setIsLoading(false)
      })

    axios.get(`${process.env.REACT_APP_API_URL}/chaise/lister6`)
      .then(res => setChaiseThumb(res.data?.[0]?.image || null))
      .catch(() => setChaiseThumb(null))
  }, [])

  const bureauThumb = infob[0]?.image || null

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  const cards = infob.map((card) => (
    <motion.div
      key={card._id}
      className='col-lg-3 col-md-4 col-6 mb-4'
      variants={itemVariants}
    >
      <Sectionbureau
        nom={card.nom}
        titre={card.titre}
        prix={card.prix1}
        image={card.image}
        id={card._id}
      />
    </motion.div>
  ))

  return (
    <div className='container hd-selection py-5'>
      <motion.div
        className="hd-selection-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="hd-selection-eyebrow">Notre sélection</span>
        <h2 className="hd-selection-title">
          Espaces <em>Bureau</em>
          <motion.span
            className="hd-selection-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          />
        </h2>
        <p className="hd-selection-subtitle">
          Découvrez notre sélection exclusive de bureaux design et fonctionnels
        </p>
      </motion.div>

      {isLoading ? (
        <div className="d-flex justify-content-center py-5">
          <div className="spinner-grow hd-selection-spinner" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
      ) : (
        <motion.div
          className='row'
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {cards}
        </motion.div>
      )}

      <motion.div
        className="hd-selection-more"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <Link to="/bureau" className="hd-selection-btn">
          <span>Voir toute la collection</span>
          <FiArrowRight />
        </Link>
      </motion.div>

      {/* Bannières de catégories */}
      <motion.div
        className='row gy-4 mt-5'
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <Link className='col-md-6 hd-selection-banner' to="/bureau">
          {bureauThumb && (
            <span className="hd-selection-banner-thumb">
              <img src={bureauThumb} alt="" />
            </span>
          )}
          <span className="hd-selection-banner-eyebrow">Explorez</span>
          <h3 className="hd-selection-banner-label">Bureau</h3>
          <div className="hd-selection-banner-content">
            <span className="hd-selection-banner-cta">Voir la collection</span>
            <span className="hd-selection-banner-arrow">
              <FiArrowUpRight />
            </span>
          </div>
        </Link>

        <Link className='col-md-6 hd-selection-banner' to="/chaise">
          {chaiseThumb && (
            <span className="hd-selection-banner-thumb">
              <img src={chaiseThumb} alt="" />
            </span>
          )}
          <span className="hd-selection-banner-eyebrow">Explorez</span>
          <h3 className="hd-selection-banner-label">Chaise</h3>
          <div className="hd-selection-banner-content">
            <span className="hd-selection-banner-cta">Voir la collection</span>
            <span className="hd-selection-banner-arrow">
              <FiArrowUpRight />
            </span>
          </div>
        </Link>
      </motion.div>

      <motion.div
        className="hd-selection-divider"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      />
    </div>
  )
}

export default Selectin
